import { Component, OnInit } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { Router } from '@angular/router';
import { ToastService } from '../../../../services/toast.service';
import { ProducaoParam } from '../../../../types/ProducaoParam.type';
import { ProducaoParamService } from './producaoparam.service';

@Component({
  selector: 'app-producaoparam',
  templateUrl: './producaoparam.component.html',
  styleUrl: './producaoparam.component.css',
  providers: [ConfirmationService]
})
export class ProducaoParamComponent implements OnInit {
  loading: boolean = false;
  producaoParams: ProducaoParam[] = []

  statusOptions = [
    { label: 'Ativo', value: true },
    { label: 'Inativo', value: false },
  ];

  empresas: string[] = [];
  variedades: string[] = [];

  constructor(private producaoParamService: ProducaoParamService, private router: Router,
              private toastService: ToastService, private confirmationService: ConfirmationService) {}

  ngOnInit(){
    this.carregarProducaoParams();
  }

  carregarProducaoParams(){
    this.loading = true;
    this.producaoParams = [];
    this.producaoParamService.getList().subscribe({
      next: (data) => {
        this.producaoParams = data
        this.empresas = [...new Set(data.map(p => p.empCodemp))].sort();
        this.variedades = [...new Set(data.map(p => p.varCodigo))].sort();
      },
      error: (error) => {
        this.loading = false;
        this.toastService.erro("Erro", error.error);
      },
      complete: () => {
        this.loading = false;
      }
    })
  }

  abreNovoDialog() {
    this.router.navigate(["novo"])
  }

  alternarStatus(producaoParam: ProducaoParam) {
    if (producaoParam.ativo) {
      this.reativar(producaoParam);
    } else {
      this.confirmationService.confirm({
        message: `Tem certeza de que deseja desativar o parâmetro ${producaoParam.empCodemp}/${producaoParam.varCodigo}/${producaoParam.sufCodigo}?`,
        header: 'Confirmar desativação',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.desativar(producaoParam);
        },
        reject: () => {
          producaoParam.ativo = true;
        }
      });
    }
  }

  desativar(producaoParam: ProducaoParam) {
    this.producaoParamService.delete(producaoParam.empCodemp, producaoParam.varCodigo, producaoParam.sufCodigo).subscribe({
      next: () => {
        this.toastService.sucesso("Sucesso", "Parâmetro desativado com sucesso");
        this.carregarProducaoParams();
      },
      error: (value) => {
        producaoParam.ativo = true;
        this.toastService.erro("Erro", "Erro ao desativar: " + value.error);
      }
    })
  }

  reativar(producaoParam: ProducaoParam) {
    this.producaoParamService.reativar(producaoParam.empCodemp, producaoParam.varCodigo, producaoParam.sufCodigo).subscribe({
      next: (data) => {
        Object.assign(producaoParam, data);
        this.toastService.sucesso("Sucesso", "Parâmetro reativado com sucesso");
      },
      error: (value) => {
        producaoParam.ativo = false;
        this.toastService.erro("Erro", "Erro ao reativar: " + value.error);
      }
    })
  }
}
